import makeService from './api';

export default makeService('export_process');
